import { createErrorNotifier } from "../errorNotifier";
import { createI18n, ILocaleCreatorInput } from "../i18n";
import { IContext } from "./types";

function createContext(
  _appName: string,
  localeCreatorInput: ILocaleCreatorInput
): IContext {
  const errorNotifier = createErrorNotifier();
  const intl = createI18n(localeCreatorInput);

  return {
    errorNotifier,
    locale: localeCreatorInput.locale,
    intl,
  };
}
export { createContext };
